import { styled } from '@mui/material';
import { compose, palette, spacing, SpacingProps, PaletteProps } from '@mui/system';
import { FC, PropsWithChildren } from 'react';

export const UnorderedList = styled('ul')<SpacingProps>`
  ${spacing}
`;

type UnorderedListItemProps = SpacingProps & PaletteProps & PropsWithChildren;

const UnorderedListItemStyled = styled('li')<UnorderedListItemProps>`
  ${compose(spacing, palette)}
`;

export const UnorderedListItem: FC<UnorderedListItemProps> = ({ children, ...props }) => (
  <UnorderedListItemStyled {...props}>{children}</UnorderedListItemStyled>
);
